import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { auth } from "../firebase";
import { collection, addDoc, getDocs, getDoc, doc, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage } from "../firebase";

const UserProfile = () => {
  const [isLoginForm, setIsLoginForm] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phoneNumber: '',
    pinCode: '',
    city: '',
    state: '',
    address: ''
  });

  const [registerFormData, setRegisterFormData] = useState({
    registerEmail: '',
    password: '',
  });

  useEffect(() => {
    getUserData();

    const emailID = localStorage.getItem('userEmail');
    setFormData({
      email: emailID,
    })

  }, []);

  const isUser = () => {
    const userId = localStorage.getItem('userId');
    return userId;
  }

  const getUserData = async () => {
    const userId = localStorage.getItem('userId');

    if (userId) {
      const ref = doc(db, "users", userId);
      const snap = await getDoc(ref);

      let data = snap.data();

      setFormData({
        name: data?.name,
        email: data?.email,
        address: data?.address,
        phoneNumber: data?.phoneNumber,
        pinCode: data?.pinCode,
        city: data?.city,
        state: data?.state,
        address: data?.address
      })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem('userId');
    const userEmail = localStorage.getItem('userEmail');
    console.log(formData)

    try {

      await setDoc(
        doc(db, "users", userId),
        {
          name: formData.name,
          email: userEmail,
          address: formData.address,
          phoneNumber: formData.phoneNumber,
          pinCode: formData.pinCode,
          city: formData.city,
          state: formData.state,
          address: formData.address
        },
        { merge: true }
      );

    } catch (err) {
      console.error("Error adding category:", err);
    }

  };


  const loginOrRegister = async (email, password) => {
    if (isLoginForm) {
      console.log('login')
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );

        return {
          user: userCredential.user,
          isNewUser: false
        };

      } catch (error) {

      }
    } else {
      console.log('register')
      try {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        return {
          user: userCredential.user,
          isNewUser: true
        };
      } catch (error) {

      }
    }
  };


  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    try {
      const result = await loginOrRegister(
        registerFormData.registerEmail,
        registerFormData.password
      );


      localStorage.setItem('userId', result.user.uid);
      localStorage.setItem('userEmail', result.user.email);

      const emailID = localStorage.getItem('userEmail');
      setFormData({
        email: emailID,
      })

      if (result.isNewUser) {
        console.log("New user registered");
      } else {
        console.log("User logged in");
      }

      isUser();
      getUserData();
    } catch (err) {
      alert(err.message);
    }
  };

  const logoutUser = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('userId');
      localStorage.removeItem('userEmail');
      isUser();
    } catch (error) {
      console.error("Logout error:", error.message);
    }
  };

  const handleRegisterFormChange = (e) => {
    setRegisterFormData({
      ...registerFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="py-5">
      <Container>
        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3">User Profile</h1>
          <p className="lead text-muted">Provide your information for better experience</p>
        </div>

        <Row className="mb-5">
          {/* Contact Form */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                {isLoginForm == true ? <h4 className="fw-bold mb-4">Login to furrmaa</h4> : <h4 className="fw-bold mb-4">Register to furrmaa</h4>}



                {isUser() && <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Your Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="John Doe"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Email Address *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="john@example.com"
                          readOnly
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Phone Number *</Form.Label>
                        <Form.Control
                          type="number"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Pin Code *</Form.Label>
                        <Form.Control
                          type="number"
                          name="pinCode"
                          value={formData.pinCode}
                          onChange={handleChange}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">City *</Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">State *</Form.Label>
                        <Form.Control
                          type="text"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Full Address *</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Write your full address here..."
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Button
                        type="submit"
                        size="lg"
                        style={{
                          backgroundColor: '#a5cb89',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px 40px'
                        }}
                      >
                        Submit
                      </Button>

                      <Button
                        onClick={logoutUser}
                        size="lg"
                        className='mx-4'
                        style={{
                          backgroundColor: '#f34e4eff',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px 40px'
                        }}
                      >
                        Logout
                      </Button>
                    </Col>


                  </Row>
                </Form>}

                {!isUser() &&

                  <div>
                    <Form onSubmit={handleRegisterSubmit}>
                      <Row className="g-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-bold small">Email Address *</Form.Label>
                            <Form.Control
                              type="email"
                              name="registerEmail"
                              value={registerFormData.registerEmail}
                              onChange={handleRegisterFormChange}
                              placeholder="john@example.com"
                              required
                            />
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-bold small">Password *</Form.Label>
                            <Form.Control
                              type="password"
                              name="password"
                              value={registerFormData.password}
                              onChange={handleRegisterFormChange}
                              placeholder=""
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Button
                            type="submit"
                            size="lg"
                            style={{
                              backgroundColor: '#a5cb89',
                              border: 'none',
                              borderRadius: '8px',
                              padding: '12px 40px'
                            }}
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Form>

                    {isLoginForm == true ? <span className='d-flex'><p>Don't have any account?</p> <p onClick={() => setIsLoginForm(false)}> Want to Register !</p></span> : <span className='d-flex'><p>Already have an account?</p> <p onClick={() => setIsLoginForm(true)}> Want to Login !</p></span>}
                  </div>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserProfile;